import { Link, type ErrorComponentProps } from "@tanstack/react-router";
import { ForbiddenError } from "@/app/guards";

function Page({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="rounded-lg border border-zinc-200 bg-white p-8">
      <h1 className="text-lg font-semibold">{title}</h1>
      <div className="mt-2 max-w-prose space-y-3 text-sm text-zinc-500">{children}</div>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="grid min-h-dvh place-items-center bg-zinc-50 px-4 text-zinc-950">
      <Page title="Page not found">
        <p>Nothing lives at this address. Check the link, or start again from the home page.</p>
        <Link to="/" className="font-medium text-zinc-950 underline">
          Go home
        </Link>
      </Page>
    </div>
  );
}

export function ForbiddenPage({ missing }: { missing: string[] }) {
  return (
    <Page title="You don't have access to this page">
      <p>Ask an administrator to grant your role:</p>
      <ul className="list-inside list-disc font-mono text-xs text-zinc-700">
        {missing.map((permission) => (
          <li key={permission}>{permission}</li>
        ))}
      </ul>
    </Page>
  );
}

export function NoAccessPage() {
  return (
    <Page title="No workspaces available">
      <p>Your account is signed in but has no permissions yet. Ask an administrator to assign you a role.</p>
    </Page>
  );
}

export function RouteErrorPage({ error }: ErrorComponentProps) {
  if (error instanceof ForbiddenError) return <ForbiddenPage missing={error.missing} />;
  return (
    <Page title="Something went wrong">
      <p>{error.message}</p>
    </Page>
  );
}
